namespace $.$$ {

	export class $shm_ba_posts extends $.$shm_ba_posts {

		post_rows() {
			return [
				this.Title(),
				... this.page_indexes().map( index => this.Post( index ) ),
				this.Page_tools_bottom(),
			]
		}

		page_size_options() {
			return [ '25', '50', '100' ]
		}

		page_size_dict() {
			return {
				25: '25',
				50: '50',
				100: '100',
			}
		}

		page_size_num() {
			const size = Number( this.page_size() )
			return this.page_size_options().includes( String( size ) ) ? size : 25
		}

		override page_size( next?: string ) {
			if( next !== undefined ) this.page( 0 )
			return super.page_size( next )
		}

		page_count() {
			return Math.max( 1, Math.ceil( this.table_count() / this.page_size_num() ) )
		}

		page_current() {
			return Math.max( 0, Math.min( this.page(), this.page_count() - 1 ) )
		}

		page_indexes() {
			const table = this.table() as $shm_ba_data_table | null
			return table?.rows.map( ( _, index )=> index ) ?? []
		}

		page_tools() {
			return this.table_count() ? [
				this.Page_numbers(),
				this.Page_info(),
				this.Page_size_label(),
			] : []
		}

		page_tools_bottom() {
			return this.table_count() ? [
				this.Page_numbers_bottom(),
				this.Page_info_bottom(),
				this.Page_size_label_bottom(),
			] : []
		}

		page_number_rows() {
			return this.page_number_keys().map( key => key.startsWith( 'gap' ) ? this.Page_gap( key ) : this.Page_number( key ) )
		}

		page_number_rows_bottom() {
			return this.page_number_keys().map( key => key.startsWith( 'gap' ) ? this.Page_gap_bottom( key ) : this.Page_number_bottom( key ) )
		}

		page_number_keys() {
			const count = this.page_count()
			const current = this.page_current()
			if( count <= 7 ) return Array.from( { length: count }, ( _, index )=> String( index ) )

			const pages = new Set< number >([ 0, count - 1 ])
			for( let index = current - 2; index <= current + 2; ++index ) {
				if( index > 0 && index < count - 1 ) pages.add( index )
			}

			const ordered = [ ... pages ].sort( ( left, right )=> left - right )
			const keys = [] as string[]
			for( let index = 0; index < ordered.length; ++index ) {
				const page = ordered[ index ]
				const prev = ordered[ index - 1 ]
				if( index > 0 && page - prev > 1 ) keys.push( `gap-${ prev }-${ page }` )
				keys.push( String( page ) )
			}
			return keys
		}

		page_info() {
			const total = this.table_count()
			if( !total ) return '0'
			const start = this.page_current() * this.page_size_num() + 1
			const finish = Math.min( total, start + this.page_size_num() - 1 )
			return `${ start }-${ finish } из ${ total }`
		}

		page_number_title( key: string ) {
			return String( Number( key ) + 1 )
		}

		page_number_current( key: string ) {
			return Number( key ) === this.page_current()
		}

		page_pick( key: string, next?: Event ) {
			if( next === undefined ) return null
			this.page( Number( key ) )
			return next
		}

		main_sort_options() {
			return [ 'Дата', 'Комментарии', 'Вовлеченность', 'Аудитория', 'Просмотры' ]
		}

		more_sort_options() {
			return [ 'Оценка', 'Репосты', 'Лайки', 'Аудитория СМИ', 'Цитируемость СМИ' ]
		}

		visible_sort_options() {
			const selected = this.sort()
			if( this.main_sort_options().includes( selected ) ) return this.main_sort_options()
			if( !this.more_sort_options().includes( selected ) ) return this.main_sort_options()
			return [ ... this.main_sort_options(), selected ]
		}

		title_content() {
			return [
				'Посты',
				... this.visible_sort_options().map( name => this.Sort_button( name ) ),
				this.More_sort(),
				this.Title_spacer(),
				this.Page_tools(),
			]
		}

		more_sort_buttons() {
			return this.more_sort_options()
				.filter( name => !this.visible_sort_options().includes( name ) )
				.map( name => this.Sort_button( name ) )
		}

		sort_title( name: string ) {
			if( this.sort() !== name ) return name
			return `${ name } ${ this.sort_order() === 'asc' ? '↑' : '↓' }`
		}

		sort_current( name: string ) {
			return this.sort() === name
		}

		sort_pick( name: string, next?: Event ) {
			if( next === undefined ) return null
			if( this.sort() === name ) {
				this.sort_order( this.sort_order() === 'asc' ? 'desc' : 'asc' )
			} else {
				this.sort_order( 'desc' )
			}
			this.sort( name )
			this.page( 0 )
			this.More_sort().showed( false )
			return next
		}

		post_row( index: number ) {
			return ( this.table() as $shm_ba_data_table | null )?.rows[ index ] ?? null
		}

	}

}
